document.addEventListener('DOMContentLoaded', function() {
  var urlParams = new URLSearchParams(window.location.search);
  var priorityValue = urlParams.get('priority');

  if (priorityValue) {
      var ul = document.getElementById('product-grid');
      var liArr = Array.from(ul.getElementsByTagName('li'));

      liArr.sort(function(a, b) {
          var aPriority = a.getAttribute('data-priority');
          var bPriority = b.getAttribute('data-priority');

          var aContains = aPriority.includes(priorityValue);
          var bContains = bPriority.includes(priorityValue);

          if (aContains && !bContains) {
              return -1;
          } else if (!aContains && bContains) {
              return 1;
          } else {
              return 0;
          }
      });

      liArr.forEach(function(li) {
          ul.appendChild(li);
      });
  }
});